const Mdg2StoreModuleEntityFactory = {
  entities: /* @__PURE__ */ new Map(),
  getEntityFingerprint(nameSpace, entityArguments) {
    return [nameSpace, JSON.stringify(entityArguments.options)].join("_");
  },
  getInstance(EntityClass, entityArguments) {
    if (!EntityClass.nameSpace) {
      throw new Error(`Class ${EntityClass.name} is mising the required "nameSpace" static property`);
    }
    const entityFingerprint = this.getEntityFingerprint(EntityClass.nameSpace, entityArguments);
    if (this.entities.has(entityFingerprint)) {
      return this.entities.get(entityFingerprint);
    }
    const entity = new EntityClass(entityArguments);
    this.entities.set(entityFingerprint, entity);
    return entity;
  }
};

export { Mdg2StoreModuleEntityFactory };
